import IndicateFriends from '../../indicate_friends/IndicateFriends.vue'

export default {
    components: { 
        IndicateFriends
    },

    data: () => ({
        componentSelected: null,
        customItemsIndicateFriends: {}
    }),

    created(){
        this.customItemsIndicateFriends = this.DATACUSTOM.text
    },

    methods: {
        selectComponent() {
            this.componentSelected = IndicateFriends
            this.$root.$emit('selectComponent', {
                componentSelected: this.componentSelected,
                customItems: this.customItemsIndicateFriends
            })
        }
    }
}